import { ReactComponent as CheckCircle } from '../res/svg/check-circle.svg';
import { ReactComponent as CloseCircle } from '../res/svg/close-circle.svg';
import { ReactComponent as CheckCircleOutlined } from '../res/svg/disable-check-circle.svg';

export const strongRule = [
  {
    min: 8,
    message: '',
  },
  {
    pattern: /^(?=.*[a-z])(?=.*[A-Z])/,
    message: ' ',
  },
  {
    pattern: /^(?=.*[!&*)(.#$%@\-_=+<>\W|_/g])/,
    message: '  '
  }
] as const;
export const passwordRule = [
  {
    required: true,
    message: 'Ingresa tu contraseña.',
  },
] as const;
/**
 * @function validateCircleOutlined
 * @description shows the success icon or not depending on the condition
 * @return { Component }
 */
export function validateCircleOutlined(validateError: boolean) {
  return validateError ? <CloseCircle /> : <CheckCircleOutlined />;
}
/**
 * @function helperValidateInput
 * @description helper to the user form
 * @return { Component }
 */
export function helperValidateInput(
  validateInput: boolean,
  validateError: boolean,
) {
  return !validateInput ? (
    validateCircleOutlined(validateError)
  ) : (
    <CheckCircle />
  );
}
/**
 * @function helperLowerAndUpper
 * @description helper to the user form
 * @return { Component }
 */
export function helperLowerAndUpper(
  validateLowerAndUpper: boolean,
  validateError: boolean,
) {
  return !validateLowerAndUpper ? (
    validateCircleOutlined(validateError)
  ) : (
    <CheckCircle />
  );
}
/**
 * @function helperSpecialCharacters
 * @description helper to the user form
 * @return { Component }
 */
export function helperSpecialCharacters(
  validateSpecialCharacters: boolean,
  validateError: boolean,
) {
  return !validateSpecialCharacters ? (
    validateCircleOutlined(validateError)
  ) : (
    <CheckCircle />
  );
}
